// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2PiEF","title":"Header_title__12pQr","side":"Header_side__1ciM_"};